import React, { useEffect, useState } from 'react'
import {
  Form,
  Input,
  Select,
  Switch,
  Button,
  Card,
  Row,
  Col,
  Modal,
  message,
  Checkbox,
  Space,
  Table,
  Popconfirm,
  Result,
  Flex,
} from 'antd'
import { PlusOutlined, MinusOutlined, InboxOutlined } from '@ant-design/icons'
import styles from './ErrorResult.module.css'
import { clearAllCookies } from '../../../../util/handleObject'
import Cookies from 'js-cookie'
import Dragger from 'antd/es/upload/Dragger'
import _default from 'antd/es/affix/style'

const { TextArea } = Input
const ErrorResult = (props) => {
  useEffect(() => {}, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  return (
    <div>
      <Result
        status="warning"
        title={
          <div
            style={{
              backgroundColor: '#FEF9F0',
              padding: '10px 30px',
              borderRadius: '12px',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-around',
            }}
          >
            <div>总数量 {props.totalNum}</div>
            <div>成功导入 {props.successNum}</div>
            <div>导入失败 {props.errorNum}</div>
          </div>
        }
        subTitle={
          <div
            style={{
              backgroundColor: '#FEF2F2',
              padding: '16px 32px',
              borderRadius: '12px',
              border: '1px solid #FEE2E2',
              marginTop: '20px',
            }}
          >
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-start',
                color: '#991B1B',
              }}
            >
              失败详情
            </div>
            <div
              style={{
                padding: '10px 10px',
                borderRadius: '12px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                color: '#EF5754',
                width: '100%',
              }}
            >
              <div style={{ width: '60px', marginRight: '10%' }}>行号</div>
              <div>失败原因</div>
            </div>
            {props.errorList.map((item, index) => (
              <div
                key={index}
                style={{
                  padding: '10px 10px',
                  borderRadius: '12px',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  color: '#EF5754',
                  width: '100%',
                }}
              >
                <div style={{ width: '60px', marginRight: '10%' }}>
                  {index + 1}
                </div>
                <div>{item}</div>
              </div>
            ))}
          </div>
        }
        extra={
          <Button
            type="primary"
            onClick={() => {
              props.closeMethod()
            }}
          >
            返回列表
          </Button>
        }
      />
    </div>
  )
}

export default ErrorResult
